<template>
    <div :class="classes" class="col">
        <slot/>
    </div>
</template>

<script>
export default {
    name: 'column',
    props: {
        size: {
            type: String,
            default: 'col-24'
        }
    },
    computed: {
        classes() {
            return [this.size]
        }
    }
}
</script>

<style lang="stylus">
@import '../../stylus/variables'

.col
    display: block
    padding: 0 10px
    flex-shrink: 0

    &:first-child
        padding-left: 0px

    &:last-child
        padding-right: 0px

    &.col-1
        width: 4.1666%

    &.col-2
        width: 8.3333%

    &.col-3
        width: 12.5%

    &.col-4
        width: 16.6666%

    &.col-5
        width: 20.8333%

    &.col-6
        width: 25%

    &.col-7
        width: 29.1666%

    &.col-8
        width: 33.3333%

    &.col-9
        width: 37.5%

    &.col-10
        width: 41.6666%

    &.col-11
        width: 45.8333%

    &.col-12
        width: 50%

    &.col-13
        width: 54.1666%

    &.col-14
        width: 58.3333%

    &.col-15
        width: 62.5%

    &.col-16
        width: 66.6666%

    &.col-17
        width: 70.8333%

    &.col-18
        width: 75%

    &.col-19
        width: 79.1666%

    &.col-20
        width: 83.3333%

    &.col-21
        width: 87.5%

    &.col-22
        width: 91.6666%

    &.col-23
        width: 95.8333%

    &.col-24
        width: 100%

    @media screen and (max-width: 480px)
        &.col-1, &.col-2, &.col-3, &.col-4, &.col-5, &.col-6, &.col-7, &.col-8, &.col-9, &.col-10, &.col-11, &.col-12, &.col-13, &.col-14, &.col-15, &.col-16, &.col-17, &.col-18, &.col-19, &.col-20, &.col-21, &.col-22, &.col-23, &.col-24
            width: 100%

        &:first-child
            padding-left: 10px

        &:last-child
            padding-right: 10px
</style>
